import { render, staticRenderFns } from "./ProductPicture.vue?vue&type=template&id=4980fbbf&scoped=true"
import script from "./ProductPicture.vue?vue&type=script&lang=js"
export * from "./ProductPicture.vue?vue&type=script&lang=js"
import style0 from "./ProductPicture.vue?vue&type=style&index=0&id=4980fbbf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4980fbbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4980fbbf')) {
      api.createRecord('4980fbbf', component.options)
    } else {
      api.reload('4980fbbf', component.options)
    }
    module.hot.accept("./ProductPicture.vue?vue&type=template&id=4980fbbf&scoped=true", function () {
      api.rerender('4980fbbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductPicture.vue"
export default component.exports